<template>
  <div class="order-page">
    <magazine-order-info-black :magazineList="magazineListRes" />


    <div class="page">
      <!-- 
      <div class="card banner">
        <img :src="banner" alt="">
      </div> -->

      <div class="title">{{ L('两岸统一收订') }}</div>

      <div class="card">
        <el-row :gutter="isPc != 3 ? 20 : 0">
          <el-col :span="isPc != 3 ? 8 : 24" v-for="item in bankList" :key="item.label">
            <div class="bank">
              <div class="area">{{ L(item.area) }}</div>
              <div class="info-list">
                <div class="info">
                  <div class="label">{{ L('账户') }}</div>
                  <div>：{{ item.account }}</div>
                </div>
                <div class="info">
                  <div class="label">{{ L('开户行') }}</div>
                  <div>：{{ item.bank }}</div>
                </div>
                <div class="info">
                  <div class="label">{{ L('账号') }}</div>
                  <div>：{{ item.id }}</div>
                </div>
                <div class="info">
                  <div class="label">{{ L('订购热线') }}</div>
                  <div>：{{ item.tel }}</div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>

      </div>

      <div class="title">{{ L('价目表(12期/年)') }}</div>

      <div class="table-card">
        <table>
          <thead>
            <tr>
              <th>{{ L('地区') }}</th>
              <th>{{ L('邮寄方式') }}</th>
              <th>{{ L('含速递邮资') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in postList" :key="item.area">
              <td>{{ L(item.area) }}</td>
              <td>{{ L(item.type) }}</td>
              <td>{{ L(item.unit) }} {{ item.price }}</td>
            </tr>
          </tbody>
        </table>
      </div>



      <div class="title">{{ L('订阅支付') }}</div>
      <el-row :gutter="isPc != 3 ? 30 : 0">
        <el-col :span="isPc != 3 ? 4 : 24">
          <div class="card">
            <el-radio-group v-model="payType" class="pay-radio-group">
              <el-row :gutter="isPc != 3 ? 0 : 8" style="width: 100%;">
                <el-col :span="isPc != 3 ? 24 : 6">
                  <el-radio-button label="大陆">{{ L('大陆') }}</el-radio-button>
                </el-col>
                <el-col :span="isPc != 3 ? 24 : 11">
                  <el-radio-button label="中国香港、澳门">{{ L('中国香港、澳门') }}</el-radio-button>
                </el-col>
                <el-col :span="isPc != 3 ? 24 : 7">
                  <el-radio-button label="中国台湾">{{ L("中国台湾") }}</el-radio-button>
                </el-col>
              </el-row>
            </el-radio-group>
          </div>
        </el-col>
        <el-col :span="isPc != 3 ? 20 : 24">
          <div class="pay-content">
            <div v-show="payType === '中国香港、澳门'">

              <!-- <div class="title">{{ L('中国香港、澳门订阅') }}</div> -->

              <div class="card" style="padding: 30px 0;">

                <stripe-buy-button buy-button-id="buy_btn_1PM51D02lRzdIQAO9TcFwjAQ"
                  publishable-key="pk_live_51PAUGI02lRzdIQAOy0SMnbYpP6CYT4bxZHXXxjkvQQLxKUB3tM10yJ7cjp6dlwG6BlknWEhvcH046YX4u7hiATxm00bVCruEU4">
                </stripe-buy-button>

              </div>

            </div>

            <div v-show="payType === '中国台湾'">

              <!-- <div class="title">{{ L('中国台湾订阅') }}</div> -->

              <div class="card" style="padding: 30px 0;">

                <stripe-buy-button buy-button-id="buy_btn_1PM4y702lRzdIQAOi20R6Nso"
                  publishable-key="pk_live_51PAUGI02lRzdIQAOy0SMnbYpP6CYT4bxZHXXxjkvQQLxKUB3tM10yJ7cjp6dlwG6BlknWEhvcH046YX4u7hiATxm00bVCruEU4">
                </stripe-buy-button>

              </div>

            </div>

            <div v-show="payType === '大陆'">

              <!-- <div class="title">{{ L('大陆订阅') }}</div> -->

              <div class="card">

                <el-form ref="form" :model="form" class="pay-form">

                  <el-form-item :label="L('支付方式')">
                    <el-radio-group v-model="form.paymentType" class="pay-type-group">
                      <el-radio-button label="WAC2B">
                        <svg-icon icon-class="alipay" />
                        {{ L("支付宝") }}
                      </el-radio-button>
                      <el-radio-button label="WUC2B">
                        <svg-icon icon-class="unionpay" />
                        {{ L('银联云闪付') }}
                      </el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                  <div class="line"></div>
                  <el-row :gutter="isPc != 3 ? 30 : 0" class="pay-form-item ">
                    <el-col :span="isPc != 3 ? 12 : 24">
                      <el-form-item :label="L('订阅开始日期')">
                        <el-date-picker v-model="form.startDate" type="month" :placeholder="L('请选择訂閱开始日期')"
                          style="width: 100%;">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="isPc != 3 ? 12 : 24">
                      <el-form-item :label="L('订阅年数')">
                        <el-input-number v-model="years" :placeholder="L('请输入')" :min="1"></el-input-number>
                        <!-- {{ L('年') }} -->
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <div class="line"></div>
                  <el-form-item :label="L('邮寄区域')">
                    <el-select v-model="form.region" :placeholder="L('请选择')" style="width: 100%;">
                      <el-option label="香港" value="香港"></el-option>
                      <el-option label="澳门" value="澳门"></el-option>
                      <el-option label="台湾" value="台湾"></el-option>
                      <el-option label="大陆" value="大陆"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="L('邮寄地址')">
                    <el-input v-model="form.address" :placeholder="L('请输入')"></el-input>
                  </el-form-item>
                  <el-row :gutter="isPc != 3 ? 30 : 0" class="pay-form-item ">
                    <el-col :span="isPc != 3 ? 12 : 24">
                      <el-form-item :label="L('收件人')">
                        <el-input v-model="form.recipient" :placeholder="L('请输入')"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="isPc != 3 ? 12 : 24">
                      <el-form-item :label="L('收件人手机')">
                        <el-input v-model="form.mobile" :placeholder="L('请输入')"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-form-item :label="L('E-mail')">
                    <el-input v-model="form.email" :placeholder="L('请输入')"></el-input>
                  </el-form-item>
                  <div class="line"></div>

                  <el-form-item :label="L('是否开具发票')">
                    <el-switch active-color="#2C2C2E" v-model="form.needInvoice"></el-switch>
                  </el-form-item>

                  <template v-if="form.needInvoice">
                    <el-row :gutter="isPc != 3 ? 30 : 0">
                      <el-col :span="isPc != 3 ? 12 : 24">
                        <el-form-item :label="L('发票抬头')">
                          <el-input v-model="form.company" :placeholder="L('请输入')"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="isPc != 3 ? 12 : 24">
                        <el-form-item :label="L('公司税号')">
                          <el-input v-model="form.invoice" :placeholder="L('请输入')"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>

                  </template>
                  <div class="line"></div>
                  <el-form-item>
                    <el-button type="danger" @click="onSubmit" :loading="payLoading || qrcodeLoading">
                      {{ L("提交订阅") }}
                    </el-button>
                  </el-form-item>
                </el-form>


              </div>


            </div>
          </div>


        </el-col>
      </el-row>





    </div>



    <el-dialog title="支付" :visible.sync="dialogVisible" width="300px">
      <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;padding: 24px;">
        <img :src="qrcode" alt="" style="width: 240px;border-radius: 8px;margin-bottom: 16px;">
        <div>{{ L(form.paymentType === 'WAC2B' ? '请使用支付宝扫一扫' : '请使用云闪付扫一扫') }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">{{ L('关闭') }}</el-button>
        <el-button type="primary" @click="ok" :loading="statusLoading">{{ L('已支付') }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>


<script>
import magazineOrderInfoBlack from '../common/magazine-order-info-black.vue'
import banner from './order.jpg'
import { createMagazineOrder, fetchOrderStatus, getMagazineList } from "@/assets/api/magazine.js";
import QRCode from 'qrcode'
import { mapState } from "vuex";

export default {
  components: {
    magazineOrderInfoBlack
  },
  data() {
    return {
      magazineListRes: [],

      banner,

      bankList: [
        {
          area: '深圳',
          account: '台商汇信息科技(深圳)有限公司',
          bank: '招商银行深圳向西支行',
          id: '755926924110801',
          tel: '(0755)26475153'
        },
        {
          area: '香港',
          account: '永兆国际控股有限公司',
          bank: '香港匯豐銀行',
          id: '026-9-047296',
          tel: '(+852)69482248/31866082'
        },
        {
          area: '台湾',
          account: '台商匯有限公司/統編:66600716',
          bank: '第一銀行延吉分行',
          id: '152-10-175295',
          tel: '(+886)905887337/02-85218313'
        }
      ],

      postList: [
        {
          area: '台湾',
          type: '速递',
          unit: 'NTD',
          price: 2700
        },
        {
          area: '香港',
          type: '速递',
          unit: 'HKD',
          price: 650
        },
        {
          area: '澳门',
          type: '速递',
          unit: 'HKD',
          price: 650
        },
        {
          area: '大陆',
          type: '速递',
          unit: 'RMB',
          price: 600
        }
      ],

      form: {
        startDate: new Date(new Date().getFullYear(), 4),
        month: 12,
        region: undefined,
        recipient: '',
        address: '',
        email: '',
        needInvoice: false,
        invoice: '',
        paymentType: 'WAC2B',
        mobile: ''
      },

      years: 1,

      payLoading: false,

      dialogVisible: false,
      qrcodeLoading: false,
      orderDetail: {},
      qrcode: '',

      statusLoading: false,

      payType: '大陆',
      region: '台湾',
    };
  },
  computed: {
    ...mapState(["isPc"]),
  },
  mounted() {
    this.getMagazineList()
  },

  methods: {
    getMagazineList() {
      let data = {
        orderByColumn: "releaseTime",
        isAsc: "desc",
        pageNum: 1,
        pageSize: 3,
        goodsTypeDict: 1,
      }
      const formData = new FormData();
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          formData.append(key, data[key]);
        }
      }
      getMagazineList(formData).then((res) => {
        this.magazineListRes = res.data.rows.map((item) => {
          item.image = !/^http/.test(item.image)
            ? this.$imgUrl + item.image
            : item.image;
          return item;
        });
      });
    },
    cancel() {
      this.orderDetail = {}
      this.dialogVisible = false;
      this.qrcode = '';

      this.form = {
        startDate: new Date(new Date().getFullYear(), 0),
        month: 12,
        region: undefined,
        recipient: '',
        address: '',
        email: '',
        needInvoice: false,
        invoice: '',
        paymentType: 'WAC2B',
        mobile: ''
      }
    },
    ok() {

      const formData = new FormData();
      formData.append('orderNo', this.orderDetail.orderNo)
      formData.append('paymentNo', this.orderDetail.outTrace)

      this.statusLoading = true;
      fetchOrderStatus(formData).then(res => {
        this.statusLoading = false;
        console.log('res', res);

        if (res && res.data && res.data.code === 0) {
          this.$message({
            message: L(res && res.data && res.data.msg ? res.data.msg : '异常错误'),
            type: "success",
          });

          this.cancel();

        } else {
          this.$message({
            message: L(res && res.data && res.data.msg ? res.data.msg : '异常错误'),
            type: "error",
          });
        }

      }).catch(err => {
        this.statusLoading = false;
        this.$message({
          message: L(err.message),
          type: "error",
        });
      })

    },

    createQRCode(str) {
      this.qrcodeLoading = true;
      QRCode.toDataURL(str)
        .then(url => {
          this.qrcodeLoading = false;
          this.qrcode = url;
          this.dialogVisible = true;
        })
        .catch(err => {
          this.qrcodeLoading = false;
          console.error(err)
        })
    },

    onSubmit() {

      let startDate = '';

      if (this.form.startDate) {
        const year = this.form.startDate.getFullYear();
        let month = this.form.startDate.getMonth() + 1;
        if (month < 10) {
          month = '0' + month;
        }
        startDate = `${year}${month}`
      } else {
        this.$message({
          message: L('请选择订阅日期'),
          type: "error",
        });
        return;
      }


      if (!this.years) {
        this.$message({
          message: L('请填写订阅年数'),
          type: "error",
        });
        return;
      }
      this.form.month = this.years * 12;

      if (!this.form.region) {
        this.$message({
          message: L('请选择区域'),
          type: "error",
        });
        return;
      }

      if (!this.form.recipient) {
        this.$message({
          message: L('请填写收件人'),
          type: "error",
        });
        return;
      }

      // 以1开头的11位手机号
      if (!this.form.mobile || !/^1\d{10}$/.test(this.form.mobile)) {
        this.$message({
          message: L('请填写11位收件人手机'),
          type: "error",
        });
        return;
      }

      if (!this.form.email) {
        this.$message({
          message: L('请填写E-mail'),
          type: "error",
        });
        return;
      }
      if (!this.form.address) {
        this.$message({
          message: L('请填写邮寄地址'),
          type: "error",
        });
        return;
      }


      if (this.form.needInvoice) {
        if (!this.form.company) {
          this.$message({
            message: L('请填写发票抬头'),
            type: "error",
          });
          return;
        }
        if (!this.form.invoice) {
          this.$message({
            message: L('请填写公司税号'),
            type: "error",
          });
          return;
        }

      }


      const { month, region, recipient, address, email, paymentType, company, invoice, mobile } = this.form;

      const formData = new FormData();

      formData.append('startDate', startDate)
      formData.append('month', month)
      formData.append('region', region)
      formData.append('recipient', recipient)
      formData.append('address', address)
      formData.append('email', email)
      formData.append('paymentType', paymentType)

      formData.append('company', company)
      formData.append('invoice', invoice)
      formData.append('mobile', mobile)

      this.payLoading = true;
      createMagazineOrder(formData).then(res => {
        this.payLoading = false;
        console.log('res', res);

        if (res && res.data && res.data.code === 0) {
          try {
            const result = JSON.parse(res.data.data);
            this.orderDetail = result;
            this.createQRCode(result.qrCode);
          } catch (error) {
            this.$message({
              message: L('参数格式不正确'),
              type: "error",
            });
          }
        } else {

          this.$message({
            message: L(res && res.data && res.data.msg ? res.data.msg : '异常错误'),
            type: "error",
          });
        }

      }).catch(err => {
        this.payLoading = false;
        this.$message({
          message: L(err.message),
          type: "error",
        });
      })


    },

  },
};
</script>

<style scoped>
.page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
}

.banner {
  padding: 0;
}

.banner>img {
  width: 100%;
  display: block;
  border-radius: 8px;
}


.title {
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  font-weight: bold;
  font-size: 32px;
  color: #2C2C2E;
  line-height: 42px;
  text-align: left;
  font-style: normal;
  margin: 80px 0 30px;
}


.bank {
  background: #F2F2F7;
  border-radius: 8px;
  padding: 20px 0;
}


.bank .area {
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  font-weight: bold;
  font-size: 24px;
  color: #FFFFFF;
  line-height: 31px;
  text-align: left;
  font-style: normal;
  padding: 12px 30px;
  background: #E2291E;
  margin-bottom: 20px;
  position: relative;
}

.bank .area:after {
  content: '';
  display: block;
  width: 36px;
  height: 36px;
  background: #F2837D;
  position: absolute;
  top: 9.5px;
  right: 37px;
  border-radius: 50%;
}

.bank .area:before {
  content: '';
  display: block;
  width: 36px;
  height: 36px;
  background: #F1635B;
  position: absolute;
  top: 9.5px;
  right: 16px;
  border-radius: 50%;
}

.bank .info-list {
  padding: 0 30px;
}

.bank .info {
  display: flex;
  align-items: center;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #2C2C2E;
  line-height: 24px;
  text-align: left;
  font-style: normal;
}

.bank .info:last-child {
  margin-bottom: 0;
}

.bank .info .label {
  width: 70px;
  text-align-last: justify;
}

.table-card {
  border: 1px solid #E5E5EA;
  overflow: hidden;
  border-radius: 8px;

}

table {
  border: none;
  width: 100%;
  border-collapse: collapse;
}

th {
  text-align: center;
  font-weight: normal;
  background: #F2F2F7;
  border-right: 1px solid #E5E5EA;
  padding: 8px 0;
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  font-weight: bold;
  font-size: 14px;
  color: #2C2C2E;
  line-height: 24px;
  text-align: center;
  font-style: normal;
}

th:last-child {
  border-right: none;
}

td {
  background-color: #FFFFFF;
  text-align: center;
  border-right: 1px solid #E5E5EA;
  padding: 8px 0;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #2C2C2E;
  line-height: 24px;
  text-align: center;
  font-style: normal;
}

tr {
  border-bottom: 1px solid #E5E5EA;
}

tr:last-child {
  border-bottom: none;
}

td:last-child {
  border-right: none;
}

.pay-content {
  width: 100%;
  background: #F2F2F7;
  border-radius: 16px;
  padding: 0 30px;
}

.pay-form {
  display: flex;
  flex-direction: column;
}

.pay-form .el-form-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 0;
}

.pay-form .line {
  width: 100%;
  height: 1px;
  background: #E5E5EA;
  margin-top: 30px;
}

.pay-form .pay-form-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

@media screen and (max-width: 768px) {
  .page {
    padding: 20px;
  }

  .title {
    font-size: 24px;
    line-height: 31px;
    margin: 30px 0 20px;
  }

  .bank {
    padding: 10px 0;
    margin-bottom: 20px;
  }

  .bank .area {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 31px;
    text-align: left;
    font-style: normal;
    padding: 12px 20px;
    background: #E2291E;
    margin-bottom: 10px;
    position: relative;
  }

  .bank .info-list {
    padding: 0 20px;
  }

  .bank .info {
    font-size: 12px;
    line-height: 20px;
  }

  .el-radio-group {
    display: flex;
  }

}
</style>
<style lang="less">
.pay-radio-group .el-radio-button {
  width: 100% !important;
}

.pay-radio-group .el-radio-button__orig-radio+.el-radio-button__inner {
  width: 100% !important;
  height: 50px !important;
  background: #FFFFFF !important;
  border-radius: 25px !important;
  border: 1px solid #E5E5EA !important;
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  font-weight: bold;
  font-size: 16px;
  color: #2C2C2E;
  line-height: 24px;
  text-align: center;
  font-style: normal;
  margin-bottom: 16px;
}

.pay-radio-group .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  background: #E2291E !important;
  color: #FFFFFF !important;
  border: 1px solid #E2291E !important;
  box-shadow: none !important;
}

.pay-form .el-form-item__label {
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  font-weight: bold;
  font-size: 18px;
  color: #2C2C2E;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  margin-bottom: 14px;
  margin-top: 30px;
}

.pay-type-group .el-radio-button__orig-radio+.el-radio-button__inner {
  box-sizing: border-box;
  height: 50px;
  background: #FFFFFF;
  border-radius: 26px;
  border: 2px solid #E5E5EA;
  padding: 14px 28px;
  font-family: MicrosoftYaHei;
  font-size: 16px;
  color: #2C2C2E;
  line-height: 21px;
  text-align: left;
  font-style: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}

.pay-type-group .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  color: #2C2C2E !important;
  font-weight: bold;
  border: 2px solid #0072F6;
  box-shadow: none !important;
}

.pay-type-group .el-radio-button:nth-child(2) .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  border: 2px solid #FD2821;
}

.pay-type-group .el-radio-button__orig-radio+.el-radio-button__inner svg {
  width: 24px;
  height: 24px;
  margin-right: 6px;
}

.pay-form .el-form-item__content {
  width: 100%;
}

.pay-form .el-input__inner {
  font-family: MicrosoftYaHei;
  font-size: 16px;
  color: #2C2C2E;
  line-height: 21px;
  font-style: normal;
  border-radius: 8px;
  border: 1px solid #E5E5EA;
  height: 48px;
}

.pay-form .el-input-number__decrease,
.pay-form .el-input-number__increase {
  width: 48px;
  height: 46px;
  line-height: 46px;
  background: #F8F8FA;
  border-radius: 8px 0px 0px 8px;
  // border: 1px solid #E5E5EA;
  font-size: 18px;
  color: #2C2C2E;
  font-weight: bold;
}

.pay-form .el-input-number__increase {
  border-radius: 0px 8px 8px 0px;
}

.pay-form .el-input-number {
  width: 100%;
}

.pay-form .el-button {
  width: 200px;
  height: 50px;
  background: #E2291E;
  border-radius: 25px;
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  font-weight: bold;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 21px;
  text-align: center;
  font-style: normal;
  margin-top: 30px;
  margin-bottom: 30px;
  float: right;
}

@media screen and (max-width: 768px) {
  .pay-radio-group .el-radio-button__orig-radio+.el-radio-button__inner {
    height: 40px !important;
    background: #FFFFFF !important;
    font-weight: bold;
    font-size: 14px;
    line-height: 14px;
    text-align: center;
    font-style: normal;
    margin-bottom: 20px;
  }
  .pay-type-group .el-radio-button__orig-radio + .el-radio-button__inner{
    padding: 15px 14px;
  }
  .pay-content{
    padding: 0 20px!important;
  }
  .pay-form .el-form-item__label{
    margin-top: 20px;
    margin-bottom: 12px;
  }
  .pay-form .pay-form-item{
    flex-direction: column!important;
  }
  .pay-form .el-button{
    width: 100%;
  }
  
}
</style>


// WEBPACK FOOTER //
// src/views/order/index.vue